export const ProjectCard = ({ project, index = 0 }) => (
  <article
    data-testid={`project-card-${project.slug}`}
    className="reveal group border border-border bg-card transition-colors hover:border-[#FF4D00]"
    style={{ animationDelay: `${index * 70}ms` }}
  >
    <div className="overflow-hidden border-b border-border bg-muted">
      <img
        src={project.image}
        alt={project.title}
        loading="lazy"
        className="h-44 w-full object-cover grayscale transition-all duration-500 group-hover:scale-105 group-hover:grayscale-0 sm:h-52"
      />
    </div>
    <div className="p-6">
      <div className="font-mono-label mb-3 flex items-center gap-3">
        <span>{project.type}</span>
        <span className="h-px w-4 bg-border" />
        <span>{project.year}</span>
      </div>
      <h3 className="text-xl font-bold">{project.title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{project.subtitle}</p>
      <p className="mt-4 border-l-2 border-[#FF4D00] pl-3 text-sm leading-relaxed">{project.outcome}</p>
      <div className="mt-5 flex flex-wrap gap-2">
        {project.stack.map((s) => (
          <span key={s} className="border border-border px-2 py-1 text-xs text-muted-foreground">
            {s}
          </span>
        ))}
      </div>
    </div>
  </article>
);
